import React, { forwardRef } from 'react';
import isPropValid from '@emotion/is-prop-valid';
import { themed } from '@indeed/ifl-css';
import { useTheme } from '@emotion/react';
import { useIconProviderContext } from './IconProvider.js';

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

const viewboxSizes = {
  xs: 18,
  sm: 20,
  md: 24
};
const svgSizes = {
  xs: "1.125rem",
  sm: "1.25rem",
  md: "1.5rem"
};
const baseStyles = _ref => {
  let {
    color = "inherit",
    size = "md"
  } = _ref;
  return {
    inlineSize: svgSizes[size],
    blockSize: svgSizes[size],
    color
  };
};
const rejectedAttributes = new Set(["color", "size"]);
const StyledSVG = themed("svg", {
  styleProps: ["color", "size"],
  shouldForwardProp: prop => isPropValid(prop) && !rejectedAttributes.has(prop)
})(baseStyles);
const Icon = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    children,
    fill = "currentColor",
    paths,
    size = "md",
    variant,
    title,
    useDirection = false,
    ...remainingProps
  } = _ref2;
  let viewBox;
  // TODO: paths with size should be removed in IFL 7.0
  if (paths && size in paths) {
    viewBox = `0 0 ${viewboxSizes[size]} ${viewboxSizes[size]}`;
  } else {
    viewBox = `0 0 24 24`;
  }
  const theme = useTheme();
  const {
    variant: variantFromContext
  } = useIconProviderContext();
  const computedVariant = variant ? variant : variantFromContext ? variantFromContext : "filled";
  const direction = useDirection && theme.direction === "rtl" && paths && (paths[`${computedVariant}${theme.direction}`] || paths[`${size}${theme.direction}`]) ? theme.direction : "";
  let pathKey;
  // TODO: paths with size should be removed in IFL 7.0
  if (paths && (size in paths || "sm" in paths || "md" in paths)) {
    pathKey = `${size}${direction}`;
  } else {
    pathKey = `${computedVariant}${direction}`;
  }
  return /*#__PURE__*/React.createElement(StyledSVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    ref: ref,
    fill: fill,
    size: size,
    viewBox: viewBox
  }, remainingProps), title && /*#__PURE__*/React.createElement("title", null, title), paths ? paths[pathKey] : children);
});
Icon.displayName = "Icon";

export { Icon as I, _extends as _ };
